<template>
  <el-dialog
    :title="`danh sách ${typeFile}`"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="fn_closeDialog"
    custom-class="file-view"
    :close-on-click-modal="false"
  >
    <div v-if="status_list_files === 'error'" class="view-container">
      <el-empty
        :description="`Tải danh sách ${typeFile} thất bại. Vui lòng kiểm tra và thử lại`"
      ></el-empty>
    </div>
    <div v-else class="file-view__container">
      <!-- list file -->
      <div class="file-view__list">
        <div class="file-view__loading" v-if="status_list_files === 'loading'">
          <i class="fa-regular fa-spinner loading-icon"> </i>
          <span>Đang tải</span>
        </div>
        <div class="file-view__empty" v-if="status_list_files === 'empty'">
          <i class="fa-solid fa-circle-exclamation"></i>
          <span>Chưa có {{ typeFile }}</span>
        </div>
        <div
          v-if="status_list_files === 'have-files'"
          style="margin-bottom: 15px"
        >
          <div
            class="file-view__ids"
            v-for="(item, index) in list_files"
            :key="item.id"
          >
            <div class="icon-block">
              <div class="icon-block__img" @click="fn_renderFile(item, index)">
                <img
                  v-if="item.type === '.pdf'"
                  src="../img/pdf-icon.png"
                  :alt="`${typeFile} định dạng pdf`"
                />
                <el-image
                  v-if="item.type !== '.pdf'"
                  :src="item.thumb"
                  :alt="`${typeFile} định dạng ảnh`"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>

              <div class="icon-block__name">
                <span :title="item.name">{{ item.name }}</span>
                <span>{{ item.length }}</span>
              </div>
              <div
                v-if="item.thumb && type_view !== 'detail'"
                class="icon-block__close"
                title="Xóa"
                @click="fn_deleteFile(item.name, index)"
              >
                <i class="fa-solid fa-circle-xmark"></i>
              </div>
            </div>
          </div>
        </div>

        <el-button
          :disabled="status_list_files === 'loading'"
          type="success"
          class="file-view__add"
          @click="fn_showAddFiles()"
          v-if="type_view !== 'detail'"
        >
          <i class="fa-solid fa-circle-plus"></i>
          Tải lên {{ typeFile }}
        </el-button>
      </div>

      <div class="file-view__render">
        <el-empty
          v-if="not_file_select"
          :description="
            status_list_files === 'empty'
              ? type_view !== 'detail'
                ? `Bấm nút để tải lên ${typeFile}`
                : `Chưa có thông tin ${typeFile}`
              : `Chọn ${typeFile} để xem chi tiết`
          "
        ></el-empty>
        <div v-else class="file-view__render--content">
          <div
            class="file-view__render--content--loading"
            v-if="is_loading_file_view"
          >
            <i class="fa-regular fa-spinner loading-icon"></i>
            <span>Đang tải</span>
          </div>

          <iframe
            v-if="
              !is_loading_file_view && !not_file_select && type_file === '.pdf'
            "
            :src="url_file"
            style="width: 100%; height: 90vh"
            :alt="url_file"
          ></iframe>
          <el-image
            v-if="
              !is_loading_file_view && !not_file_select && type_file !== '.pdf'
            "
            :src="url_file"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
              <p>Lỗi</p>
            </div>
          </el-image>
        </div>
      </div>
      <div class="file-view__container--button" v-show="is_render_success">
        <el-button type="primary" v-ladda @click="fn_download">
          <i class="fa-regular fa-down-to-bracket"></i>
          Tải xuống
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import mushroom from "viettoc-api";
import MethodService from "../service/MethodService";
export default {
  props: {
    ids: Array,
    typeView: String,
    typeFile: String,
  },
  data() {
    return {
      dialogVisible: true,
      status_list_files: "loading",
      type_view: "",
      list_files: [],
      url_file: "",
      id_file: "",
      type_file: "",
      not_file_select: true,
      is_render_success: false,
      is_loading_file_view: false,
    };
  },
  methods: {
    fn_renderFile(file, index) {
      this.is_loading_file_view = true;
      this.is_render_success = false;
      this.id_file = file.id;
      this.type_file = file.type;
      this.not_file_select = false;

      const dom = document.querySelectorAll(".file-view__ids .icon-block");
      if (dom) {
        dom.forEach((el) => {
          el.classList.remove("active-block");
        });
        dom[index].classList.add("active-block");
      }

      const imgSrc = mushroom.$file.linkBuilder.thumb.id(file.id).build();
      if (imgSrc) {
        this.url_file = imgSrc;
        setTimeout(() => {
          this.is_loading_file_view = false;
          this.is_render_success = true;
        }, 1000);
      } else this.is_render_success = false;
    },
    fn_download() {
      try {
        mushroom.$file.download(this.id_file);
      } catch (e) {
        MethodService.showError(e.code);
      } finally {
        setTimeout(() => {
          MethodService.stopLadda();
        }, 1000);
      }
    },
    async fn_renderListNameFile() {
      this.status_list_files = "loading";
      this.list_files = [];
      try {
        const response = await mushroom.sto_file.listAsync({
          filters: ["id:in:" + this.ids],
        });
        if (this.ids && this.ids.length > 0) {
          response.result.forEach((item) => {
            this.ids.forEach((x) => {
              if (x === item.id) {
                this.list_files.push({
                  id: item.id,
                  name: item.name,
                  type: item.extension,
                  length: MethodService.formatBytes(item.length, 2),
                  thumb: mushroom.$file.linkBuilder.thumb
                    .id(item.id)
                    .clip(160, 200, "middle")
                    .build(),
                });
              }
            });
          });
          this.status_list_files = "have-files";
        } else {
          setTimeout(() => {
            this.status_list_files = "empty";
          }, 1000);
          return;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
        MethodService.showError(e.code);
        this.status_list_files = "error";
      }
    },

    fn_showAddFiles() {
      this.$emit("show-add-files");
    },
    fn_deleteFile(name, index) {
      this.$confirm(`Chắc chắn xóa ${this.typeFile} ${name}?`, {
        confirmButtonText: "Xóa",
        cancelButtonText: "Quay lại",
        type: "info",
      })
        .then(() => {
          this.$emit("delete-files", index);
        })
        .catch();
    },
    fn_closeDialog() {
      this.$emit("close-dialog");
    },
  },
  async created() {
    this.type_view = this.typeView;
    await this.fn_renderListNameFile();
  },
};
</script>
<style scoped lang="scss">
.icon-block {
  text-align: center;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  &:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  }
  &__img {
    background-color: #d7d7d71a;
    min-height: 130px;
  }
  &__close {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
    color: #f56c6c;
    transition: 0.2s;
    &:hover {
      color: red;
    }
  }
  &__name {
    position: absolute;
    bottom: 0;
    color: #fff;
    background-color: rgba(65, 65, 65, 0.5);
    padding: 5px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    span:nth-child(1) {
      width: calc(100% - 80px);
      text-align: start;
      display: block;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:nth-child(2) {
      width: 70px;
      text-align: end;
    }
  }
}
.active-block {
  box-shadow: 0 0 6px rgba(222, 175, 6, 0.85);
  &:hover {
    box-shadow: 0 0 6px rgba(222, 175, 6, 0.85);
  }
}
.view-container {
  width: 100%;
  height: calc(85vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.file-view {
  &__container {
    display: flex;
    justify-content: space-between;
    position: relative;
    height: calc(85vh - 175px);
    &--button {
      position: absolute;
      bottom: 0;
      right: 15px;
      i {
        padding-right: 5px;
      }
    }
  }
  &__loading,
  &__empty {
    width: 100%;
    height: calc(100% - 32px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__empty i {
    margin-right: 7px;
    color: #e6a23c;
  }
  &__list {
    overflow-y: auto;
    overflow-x: hidden;
    width: 250px;
    padding: 5px;
  }
  &__add {
    width: 100%;
    i {
      margin-right: 5px;
    }
  }
  &__ids {
    margin-bottom: 15px;
    i {
      margin-right: 5px;
    }
  }
  &__ids:last-child {
    margin-bottom: 0;
  }
  &__render {
    width: calc(100% - 280px);
    display: flex;
    justify-content: center;
    overflow-y: auto;
    overflow-x: hidden;
    &--content {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    &--content img {
      object-fit: contain;
      max-width: 1024px;
    }
    &--content--loading {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}
</style>
